import { useState, useEffect } from "react";
import { API_URL } from "src/util/config";
import { checkResponse } from "src/util/helpers";
import { JournalApprovalLookupItem } from "models/journal-approval";
import { useAuth } from "src/contexts/AuthContext";

export const useJournalApprovalLookup = (ids: string[]) => {
  const [items, setItems] = useState<JournalApprovalLookupItem[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const { fetchWithReauth } = useAuth();

  const fetchDetails = async (numbers: string[]) => {
    if (numbers.length === 0) {
      setItems([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const response = await fetchWithReauth(
        `${API_URL}/netsuite/journal-approval-lookup?ids=${encodeURIComponent(
          numbers.join(",")
        )}`
      );
      const data = await checkResponse(response);
      setItems(data);
    } catch (err) {
      console.error("Error fetching journal approval lookup:", err);
      setError("Failed to fetch journal details.");
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDetails(ids);
  }, [ids]);

  return {
    items,
    loading,
    error,
    refetch: () => fetchDetails(ids),
  };
};
